"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEmailSend = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconEmailSend = function IconEmailSend(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.867 5H5.333C4.16 5 3.2 5.997 3.2 7.215v.831c0 .305.24.554.533.554.294 0 .534-.25.534-.554v-.83c0-.111.026-.222.053-.333l5.973 5.317-5.973 5.317a1.418 1.418 0 01-.053-.332v-.831a.545.545 0 00-.534-.554.546.546 0 00-.533.554v.83c0 1.22.96 2.216 2.133 2.216h16.534c1.173 0 2.133-.997 2.133-2.215v-9.97C24 5.997 23.04 5 21.867 5zM5.12 6.135c.053-.027.133-.027.213-.027h16.534c.08 0 .16 0 .213.027l-8.133 7.228a.546.546 0 01-.694 0L5.12 6.135zm16.747 12.157H5.333c-.08 0-.16 0-.213-.027l6-5.345 1.44 1.302a1.515 1.515 0 002.08 0l1.44-1.302 6 5.345c-.053.027-.133.027-.213.027zm1.066-1.107c0 .11-.026.221-.053.332L16.907 12.2l5.973-5.317c.027.11.053.222.053.332v9.97zM1.6 10.815c0-.304.24-.553.533-.553h3.2c.294 0 .534.249.534.553 0 .305-.24.554-.534.554h-3.2a.545.545 0 01-.533-.554zm3.733 3.323h-4.8A.545.545 0 010 13.585c0-.305.24-.554.533-.554h4.8c.294 0 .534.249.534.554 0 .304-.24.553-.534.553z"
  }));
};
exports.IconEmailSend = IconEmailSend;